export default __webpack_public_path__ + "static/media/StarWarsEncyclopedia.3d433a88.png";